import * as yup from 'yup';
import { phoneRegExp } from '../../../utils/validation.ts';

export interface UpdateContactInformationValues {
  firstName: string;
  lastName: string;
  phone: string;
  textOrEmailPreference: string;
}

export const UpdateContactInformationInitialValues: UpdateContactInformationValues =
  {
    firstName: '',
    lastName: '',
    phone: '',
    textOrEmailPreference: '',
  };

export const UpdateContactInformationValidationSchema = yup.object({
  firstName: yup.string().required('First Name'),
  lastName: yup.string().required('Last Name'),
  phone: yup
    .string()
    .matches(phoneRegExp, 'Phone number is not valid')
    .required('Phone'),
  textOrEmailPreference: yup.string().required('Contact preference'),
});
